import axios from "axios";

export const getProductAffirmIntreset = (amount) => async (dispatch) => {
  const _config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PUT, DELETE",
      "Access-Control-Allow-Headers":
        "Content-Type, X-Auth-Token, Origin, Authorization",
    },
    mode: "no-cors",
  };
  var price = amount * 100;
  // console.log(formData);
  // const token = localStorage.getItem("token");
  // if (token) {
  //   setAuthHeader(token);
  // }
  try {
    // Where we're fetching data from
    const res = await fetch(
      `https://www.affirm.com/api/promos/v2/ANKROXY05OF5VHAP?amount=${price}&field=ala&logo_color=blue&logo_type=logo&page_type=category&show_cta=true`
    );
    // We get the API response and receive data in JSON format...
    return (
      res
        .json()
        // Catch any errors we hit and update the app
        .catch((error) => this.setState({ error, isLoading: false }))
    );

    // const res = await axios.get(
    //   `https://www.affirm.com/api/promos/v2/ANKROXY05OF5VHAP?amount=${price}&field=ala&logo_color=blue&logo_type=logo&page_type=category&show_cta=true`,
    //   _config
    // );
    // return res.data;
  } catch (err) {
    console.log(err);
  }
};
